import axiosClient from "./axiosClient";

export const getNotificationSettings = async (storeUuid) => {
    const response = await axiosClient.get(`/stores/${storeUuid}/notifications`);
    return response.data.data.notification_settings ?? null;
};

export const createNotificationSettings = async (storeUuid, data) => {
    const response = await axiosClient.post(`/stores/${storeUuid}/notifications`, data);
    return response.data.data;
};

export const updateNotificationSettings = async (storeUuid, data) => {
    const response = await axiosClient.patch(`/stores/${storeUuid}/notifications`, data);
    return response.data.data;
};
